import { type Duration } from "moment-timezone";
import React from "react";

import { ClockIcon } from "veneer/SvgIcon";

import {
  Device,
  DeviceStatsApiResponse,
} from "cortex/ui/src/fleet/view/device/model";
import InfoBox from "cortex/ui/src/ui/info-box";
import { type Color } from "cortex/ui/src/ui/info-box/common";
import { MinuteRender } from "cortex/ui/src/ui/minute-render";
import {
  calculateTimeDiff,
  formatDateFromDifference,
  timeDifferenceWithTimezone,
} from "cortex/ui/src/util/time";

interface DeviceLocalTimeBoxProps {
  color: Color;
  device: Device;
  stats: DeviceStatsApiResponse;
}

interface InnerDeviceLocalTimeBoxProps {
  color: Color;
  timeDiff: Duration | null;
  timezone: string | null;
}

export default function DeviceLocalTimeBox({
  color,
  device,
  stats,
}: DeviceLocalTimeBoxProps) {
  const time = stats?.player?.localTime || null;
  const timezone = device?.timezone || null;
  const timeDiff = timeDifferenceWithTimezone(time, timezone);

  return (
    <MinuteRender>
      <InnerDeviceLocalTimeBox
        color={color}
        timeDiff={timeDiff}
        timezone={timezone}
      />
    </MinuteRender>
  );
}

const InnerDeviceLocalTimeBox = ({
  color,
  timeDiff,
  timezone,
}: InnerDeviceLocalTimeBoxProps) => {
  const parsedTime = formatDateFromDifference(timeDiff, "hh:mm a");
  const parsedDate = formatDateFromDifference(timeDiff, "MMM Do, YYYY");
  const subText = `${parsedDate} | TZ (${timezone})`;

  return (
    <InfoBox
      color={color}
      desc={`${parsedTime} (${calculateTimeDiff(timeDiff)})`}
      icon={<ClockIcon size="large" />}
      subText={subText}
      title="Device Time"
    />
  );
};
